import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
* Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP PDF View 개발
 *
 ********************************************************************/
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useSearchParams, useParams } from 'react-router-dom';
// css
import "/static/css/viewer.css";
// utils
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import PdfViewer from "./PdfViewer";
/**
 * @brief EHP PDF View 컴포넌트
 * @param -
 * @returns react components
 */
function EhpPdfViewer(props) {
    const params = useParams();
    const searchParams = useSearchParams();
    const location = useLocation();
    const ehpParams = location.hasOwnProperty("search")
        ? location.search.split(CONST.STR_PARAM_DATA)
        : [];
    let pdfNm = "";
    let pdfUrl = "";
    for (let i = 0; i < ehpParams.length; i++) {
        if (CONST.STR_PARAM_PDFID == ehpParams[i].substring(0, CONST.STR_PARAM_PDFID.length)) {
            pdfUrl = ehpParams[i].substring((CONST.STR_PARAM_PDFID + "=").length, ehpParams[i].length);
        }
        if (CONST.STR_PARAM_PDFNM == ehpParams[i].substring(0, CONST.STR_PARAM_PDFNM.length)) {
            pdfNm = (ehpParams[i].substring(ehpParams[i].length - 1) == "&")
                ? ehpParams[i].substring((CONST.STR_PARAM_PDFNM + "=").length, ehpParams[i].length - 1)
                : ehpParams[i].substring((CONST.STR_PARAM_PDFNM + "=").length, ehpParams[i].length);
        }
    }
    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [dispPage, setDispPage] = useState("1");
    const [viewerSize, setViewerSize] = useState({
        width: window.innerWidth * 0.852,
        height: window.innerHeight * 0.852,
    });
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            setViewerSize({
                width: mobileTag.clientWidth,
                height: mobileTag.clientHeight
            });
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [mobileRef]);
    function downloadFile(fname, fileLink) {
        HttpUtil.fileDownload(decodeURI(fname), fileLink);
    }
    function handleFocusOut(e) {
        if (dispPage.length <= 0) {
            handleSetPageNumber(1);
        }
        else {
            handleSetPageNumber(dispPage);
        }
    }
    function handleEnterKey(e) {
        if (e.key === 'Enter') {
            handleFocusOut(e);
        }
    }
    function handleSetDispPage(e) {
        var val = e.target.value;
        setDispPage(val.replace(/[^0-9]/g, ""));
    }
    function handleSetPageNumber(val) {
        var page = parseInt(val);
        page = (page > numPages) ? numPages : page;
        page = (page < 1) ? 1 : page;
        setPageNumber(page);
        setDispPage(page.toString());
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "viewer" }, { children: [_jsxs("div", Object.assign({ className: "viewer__top" }, { children: [_jsx("h1", { children: decodeURI(pdfNm) }), _jsxs("div", Object.assign({ className: "paging__area" }, { children: [_jsx("p", { children: "Page" }), _jsxs("ul", Object.assign({ className: "paging__button" }, { children: [_jsx("li", Object.assign({ className: `btn-prev ${(pageNumber > 1) ? "" : "disabled"}`, onClick: (e) => (pageNumber > 1) && handleSetPageNumber(pageNumber - 1) }, { children: _jsx("a", { children: "\uC774\uC804 \uD398\uC774\uC9C0\uB85C" }) })), _jsxs("li", Object.assign({ className: "viewpaging__select" }, { children: [_jsx("input", { type: "text", value: dispPage, onChange: (e) => handleSetDispPage(e), onKeyDown: (e) => handleEnterKey(e), onBlur: (e) => handleFocusOut(e) }), _jsxs("span", { children: ["/", numPages] })] })), _jsx("li", Object.assign({ className: `btn-next ${(pageNumber < numPages) ? "" : "disabled"}`, onClick: (e) => (pageNumber < numPages) && handleSetPageNumber(pageNumber + 1) }, { children: _jsx("a", { children: "\uB2E4\uC74C \uD398\uC774\uC9C0\uB85C" }) }))] }))] })), _jsxs("div", Object.assign({ className: "top__right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-down", onClick: () => downloadFile(pdfNm, pdfUrl) }, { children: _jsx("span", { children: "Download" }) })), _jsx("img", { src: require("/static/img/icon_logo.png"), alt: "LS\uC0B0\uC804" })] }))] })), _jsx("div", Object.assign({ className: "viewer__document", ref: mobileRef }, { children: _jsx(PdfViewer, { file: pdfUrl, viewerSize: viewerSize, numPages: numPages, setNumPages: setNumPages, pageNumber: pageNumber, setPageNumber: setPageNumber }) }))] })) }));
}
export default EhpPdfViewer;
